module.exports = __webpack_public_path__ + "img/snake_control_down.ac367fb1.svg";